import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingViewSidebar } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebar';
import { ListingViewSidebarContent } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebarContent';
import { ListingViewSidebarImage } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebarImage';
import { ListingViewSidebarLinks } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebarLinks';
import { ListingViewSidebarTitle } from '#/modules/listing/components/ListingView/Sidebar/ListingViewSidebarTitle';
import { ViewListingPageSidebarResults } from '#/modules/listing/components/ListingView/Sidebar/ViewListingPageSidebarResults';
import { ListingViewStatus } from '#/modules/listing/types/ListingViewStatus';
import type { ApiVolop } from '#/modules/listing/volops/api/types/ApiVolop';
import { useSearchContextHeader } from '#/modules/search/containers/SearchContextHeader/useSearchContextHeader';
import { useSearchFilterType } from '#/modules/search/contexts/SearchContext';
import { useSearchSavedListingsStore } from '#/modules/search/zustand-stores/searchSavedListingsStore';

type Props = {
  applied: boolean;
  listingDetailsSearchResultsEnabled: boolean;
  volop: ApiVolop;
};

export function ViewVolopPageSidebar({
  applied,
  listingDetailsSearchResultsEnabled,
  volop,
}: Props) {
  const { address, firstPublished, hasAts, id, name, org, remoteOptions } =
    volop;
  const { locale } = useI18n();
  const { searchContext } = useSearchContextHeader({ currentObjectId: id });
  const { searchSavedListingsStore } = useSearchSavedListingsStore();

  const orgLogo = org?.logo ?? null;
  const orgName = org?.name ?? null;
  const orgUrl = org?.url[locale] ?? null;

  const isVolopSearch = useSearchFilterType() === 'VOLOP';

  if (searchContext && isVolopSearch && listingDetailsSearchResultsEnabled) {
    return (
      <ListingViewSidebar>
        <ViewListingPageSidebarResults
          listing={volop}
          searchContext={searchContext}
          searchSavedListingsStore={searchSavedListingsStore}
        />
      </ListingViewSidebar>
    );
  }

  return (
    <ListingViewSidebar maxWidth={288}>
      <ListingViewSidebarImage
        orgLogo={orgLogo}
        orgName={orgName}
        orgURLForCurrentLocale={orgUrl}
      />
      <ListingViewSidebarTitle
        address={address}
        listingName={name}
        listingType="VOLOP"
        orgName={orgName}
        orgUrl={orgUrl}
        remoteOptions={remoteOptions}
      />
      <ListingViewSidebarContent
        firstPublished={firstPublished}
        applied={applied}
        listingType="VOLOP"
        showScrollToApplyButton={hasAts}
        listingViewStatus={ListingViewStatus.PUBLISHED}
      />
      <ListingViewSidebarLinks searchContext={searchContext} orgUrl={orgUrl} />
    </ListingViewSidebar>
  );
}
